<template>
    <div>
        <ui-modal v-ref:duplicate-modal :width="900" :hide-close="true" :backdrop-clickable="false">
            <div slot="header">
                Duplicar imóvel
            </div>
            <div>
                <ui-loading :state="ui.loading">
                    <form name="duplicatedProperty" v-el:duplicate-modal-form v-if="duplicatedProperty && options">
                        <div v-if="duplicatedProperty && ui.isDuplicated">
                            <div style="text-align: center">
                                <h2 class="text-center">Imóvel duplicado!</h2>
                                <div class="text-center">
                                    <div style="margin-bottom: 15px">Novo código: {{ duplicatedProperty.user_code }}</div>
                                    <div class="fa fa-check-circle font-green" style="font-size: 30px"></div>
                                </div>
                            </div>
                        </div>
                        <div v-if="duplicatedProperty && !ui.isDuplicated">
                            <div class="row">
                                <div class="col-xs-4">
                                    <form-text :model.sync="duplicatedProperty.alternative_code" :disabled="options.generate_alternative_code">
                                        <span slot="label">
                                            Novo Código Alternativo
                                            <form-required :state="options.use_alternative_code" message="Obrigatório<br />Não usar espaço ou virgula."></form-required>
                                        </span>
                                    </form-text>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-8">
                                    <div style="margin-bottom: 15px; margin-top: -11px">
                                        <div v-if="property.code">
                                            Código original: <b>{{ property.code }}</b>
                                        </div>
                                        <div v-if="property.alternative_code">
                                            Código alternativo original: <b>{{ property.alternative_code }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <form-addressing :model.sync="duplicatedProperty"
                                                     :with-zone="true"
                                                     :with-alternative-neighborhood="true"
                                                     :with-land-fields="true"
                                                     :required="true"
                                                     :required-fields="['neighborhood_id', 'city_id', 'state_id', 'zipcode', 'street', 'street_number']"
                                    ></form-addressing>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <form-select :model.sync="duplicatedProperty.receiver1_id" label="Captador 1" :options.sync="options.users"></form-select>
                                    <div v-if="property.receiver1" style="margin-bottom: 15px; margin-top: -11px;">
                                        Original: <b>{{ property.receiver1.name }}</b>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <form-select :model.sync="duplicatedProperty.receiver2_id" label="Captador 2" :options.sync="options.users"></form-select>
                                    <div v-if="property.receiver2" style="margin-bottom: 15px; margin-top: -11px;">
                                        Original: <b>{{ property.receiver2.name }}</b>
                                    </div>
                                </div>
                            </div>

                            <h4 class="h4-with-line">Divulgação</h4>

                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>
                                            Título
                                            <i class="fa fa-question-circle icon-ajuda"
                                               v-tooltip
                                               title="Título do imóvel que aparece no anúncio dos sites e portais. Esse título também é utilizado no google para ajudar na otimização."
                                            ></i>
                                        </label>
                                        <input type="text" class="form-control"
                                               maxlength="63" name="defaultconfig"
                                               id="maxlength_alloptions"
                                               v-model="duplicatedProperty.website_title"
                                               v-on:keypress="disableAutoTitle()"
                                               style="padding-right: 30px">
                                        <button type="button"
                                                class="btn btn-transparent"
                                                style="position: absolute; top: 24px; right: 15px" v-on:click="fillTitle(true)"
                                                v-tooltip
                                                title="Atualizar com as informações do imóvel">
                                            <i class="fa fa-refresh"></i>
                                        </button>
                                        <div style="margin-top: 4px">
                                            <form-new-check label="Preencher titulo automaticamente?" :model.sync="duplicatedProperty.is_website_title_automatic"></form-new-check>
                                        </div>
                                        <div v-if="duplicatedProperty.website_title">
                                            <div style="margin: 10px 0">{{ duplicatedProperty.website_title.length }} caracteres</div>
                                            <div v-if="duplicatedProperty.website_title.length > 50" class="alert alert-warning" style="margin: 0; padding: 8px">
                                                <div class="fa fa-info"></div>
                                                Alguns portais pedem que o título tenha no máximo <b>50 caracteres</b>.
                                            </div>
                                        </div>
                                        <div class="form-group">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group">
                                                <label>Palavra-Chave (Keywords) <i class="fa fa-question-circle icon-ajuda" v-tooltip title="Palavras que resumem o anúncio do imóvel, elas são importantes para a otimização no google"></i></label>
                                                <input type="text" class="form-control" maxlength="160"
                                                       name="defaultconfig"
                                                       id="maxlength_keywords"
                                                       v-maxlength
                                                       v-model="duplicatedProperty.website_keywords"
                                                       v-on:keypress="disableAutoKeywords()">
                                                <button type="button"
                                                        class="btn btn-transparent"
                                                        style="position: absolute; top: 24px; right: 15px" v-on:click="fillKeywords(true)"
                                                        v-tooltip
                                                        title="Atualizar com as informações do imóvel">
                                                    <i class="fa fa-refresh"></i>
                                                </button>
                                                <div style="margin-top: 4px">
                                                    <form-new-check label="Preencher palavra-chave automaticamente?" :model.sync="duplicatedProperty.is_website_keywords_automatic"></form-new-check>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group">
                                                <label>Descrição <i class="fa fa-question-circle icon-ajuda" v-tooltip title="Descrição do imóvel que aparecerá no anúncio do google, como no exemplo ao lado"></i></label>
                                                <input type="text" class="form-control" maxlength="160"
                                                       name="defaultconfig" id="maxlength_description" v-maxlength v-model="duplicatedProperty.website_description">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6" v-if="options.website">
                                    <h4><i class="fa fa-eye"></i> Exemplo</h4>
                                    <div class="snippet-preview well">
                                        <p class="snippet-title">{{ duplicatedProperty.website_title || 'Título do imóvel - ' + options.website.name }}</p>
                                        <p class="snippet-url">{{ options.website.user_domain }}/</p>
                                        <p class="snippet-desc">{{ duplicatedProperty.website_description || 'Aqui vai a descrição do seu website imobiliário que aparecerá nos buscadores. Aqui vai a descrição do seu website imobiliário que aparecerá nos buscadores.' }}</p>
                                    </div>

                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="alert alert-sm alert-info" style="margin: 0">
                                                <i class="fa fa-info-circle"></i>
                                                O valor <b>$cod</b> será trocado pelo código do imóvel caso presente na descrição, título ou palavras-chave quando a duplicação for finalizada com sucesso.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style="background-color: #EEE; height: 2px; margin-bottom: 10px; margin-top: 10px; width: 100%"></div>

                            <div class="row">
                                <div class="col-xs-6">
                                    <form-multi-select :model.sync="duplicatedProperty.selectedWebsites" :options.sync="options.websites"
                                                       placeholder="Selecione...">
                                            <span slot="label">
                                                Websites
                                                <span v-if="duplicatedProperty.selectedWebsites.length">
                                                    (
                                                    <span class="text-link">{{ duplicatedProperty.selectedWebsites.length }} selecionados</span>
                                                    )
                                                </span>
                                            </span>
                                    </form-multi-select>
                                </div>
                                <div class="col-xs-6">
                                    <form-multi-select :model.sync="duplicatedProperty.selectedPortals" :options.sync="options.portals"
                                                       placeholder="Selecione...">
                                            <span slot="label">
                                                Portais
                                                <span v-if="duplicatedProperty.selectedPortals.length">
                                                    (
                                                    <span class="text-link">{{ duplicatedProperty.selectedPortals.length }} selecionados</span>
                                                    )
                                                </span>
                                            </span>
                                    </form-multi-select>
                                </div>
                            </div>
                        </div>
                    </form>
                </ui-loading>
            </div>
            <div slot="footer">
                <button :disabled="ui.loading" type="button" class="btn btn-default" @click="hide()" v-if="!ui.isDuplicating && !ui.isDuplicated">Cancelar</button>
                <button :disabled="ui.loading"  type="button" class="btn blue" :disabled="ui.isDuplicating" @click="duplicate()" v-if="!ui.isDuplicated">Duplicar</button>
                <button :disabled="ui.loading" type="button" class="btn btn-default" @click="hide()" v-if="!ui.isDuplicating && ui.isDuplicated">Fechar</button>
                <a class="btn blue" :href="'/properties/' + duplicatedProperty.id" v-if="duplicatedProperty && ui.isDuplicated">Ir ao imóvel</a>
            </div>
        </ui-modal>
    </div>
</template>

<script>
const Promise = require('bluebird');
const SCI = require('sci')
const client = require('sci/helpers/client');
const { vueChaos } = require('sci/helpers');
const { url, plural, formatMoney } = require('sci/utils');
const { humanizeMoney } = require('microsistec/humanize')

export default {
    props: {
        options: {}
    },
    data () {


        return {
            property: null,
            duplicatedProperty: null,
            ui: {
                loading: true,
                isDuplicating: false,
                isDuplicated: false,
            },
            unwatches: [],
        };
    },
    ready () {

    },
    destroyed () {
        this.unwatch();
    },
    methods: {
        watch () {
            this.unwatches = [
                'duplicatedProperty.neighborhood',
                'duplicatedProperty.alternative_neighborhood',
                'duplicatedProperty.neighborhood_id',
                'duplicatedProperty.alternative_neighborhood_id',
                'duplicatedProperty.city',
                'duplicatedProperty.city_id',
                'duplicatedProperty.sell_price',
                'duplicatedProperty.rent_price',
                'duplicatedProperty.total_built_area',
                'duplicatedProperty.total_useful_area',
                'duplicatedProperty.alternative_code',
                'duplicatedProperty.roomsCount',
                'duplicatedProperty.type',
                'duplicatedProperty.subtype',
                'duplicatedProperty.finality',
                'duplicatedProperty.website_hide_sell_price',
                'duplicatedProperty.website_hide_rent_price',
                'duplicatedProperty.website_hide_vacation_price',
                'duplicatedProperty.website_hide_lease_price'
            ].map((key) => this.$watch(key, () => {
                this.fillTitle();
                this.fillKeywords();
            }, { deep: true }));
        },
        unwatch () {
            this.unwatches.forEach((fn) => {
                fn();
            })
        },
        hide () {
            this.unwatch()
            this.$refs.duplicateModal.hide()
        },
        redo () {
            this.startDuplication(this.property.id)
        },
        disableAutoTitle () {
            this.duplicatedProperty.is_website_title_automatic = false
        },
        disableAutoKeywords () {
            this.duplicatedProperty.is_website_keywords_automatic = false
        },
        duplicate() {
            if (this.ui.isDuplicating) {
                return
            }
            this.ui.isDuplicated = false
            this.ui.isDuplicating = true

            const form = this.$els.duplicateModalForm
            const data = JSON.parse(JSON.stringify(this.duplicatedProperty))

            data.selectedWebsites = data.selectedWebsites.map(_ => _.id)
            data.selectedPortals = data.selectedPortals.map(_ => _.id)

            client
                .silent()
                .block(form)
                .post(`Criando Imóvel...`,
                    `/properties/${this.duplicatedProperty.id}/duplicate`, data)
                .then(vueChaos(form))
                .then((res) => {
                    this.ui.isDuplicating = false
                    this.ui.isDuplicated = true
                    this.duplicatedProperty = res
                })
                .catch(() => {
                    this.ui.isDuplicating = false
                    this.ui.isDuplicated = false
                })
        },
        startDuplication(id) {
            this.options = {};
            this.duplicatedProperty = null;
            this.property = null;
            this.ui.loading = true;
            this.ui.isDuplicated = false
            this.ui.isDuplicating = false
            Promise.props({
                optionsRes: client.get('Carregando informações...', '/properties/options'),
                propertyRes: client.get('Carregando imóvel...', `/properties/${id}`)
            }).then(({ optionsRes, propertyRes }) => {
                const property = propertyRes.data
                const duplicatedProperty = JSON.parse(JSON.stringify(property));
                const options = optionsRes.data

                duplicatedProperty.code = null;
                duplicatedProperty.alternative_code = null;
                duplicatedProperty.user_code = null;
                duplicatedProperty.selectedWebsites = duplicatedProperty.websites || []
                duplicatedProperty.selectedPortals = duplicatedProperty.portals || []
                duplicatedProperty.receiver1_id = this.$user.id;
                duplicatedProperty.receiver2_id = null;
                // duplicatedProperty.website_keywords = null;
                // duplicatedProperty.website_title = null;
                // duplicatedProperty.website_description = null;
                // duplicatedProperty.is_website_title_automatic = true;
                // duplicatedProperty.is_website_keywords_automatic = true;

                this.duplicatedProperty = duplicatedProperty;
                this.property = property;
                this.options = options;
                this.ui.loading = false;

                this.watch()

                this.$nextTick(() => {
                    this.fillKeywords()
                    this.fillTitle()
                })
            })
        },
        show(id) {
            this.startDuplication(id)
            this.$refs.duplicateModal.show()
        },


        fillTitle(active = false) {
            let title = [];
            let { duplicatedProperty } = this;

            if (!duplicatedProperty) {
                return
            }

            if (!duplicatedProperty.is_website_title_automatic && !active) {
                return
            }


            if (duplicatedProperty.typeInfo) {
                let part = [];
                part.push(duplicatedProperty.typeInfo.name);
                if (duplicatedProperty.roomsCount.dorm) {
                    part.push(plural(duplicatedProperty.roomsCount.dorm, "com %s dorm", "com %s dorms"));
                }
                title.push(part.join(" "));
            }

            if (duplicatedProperty.alternative_neighborhood_id && duplicatedProperty.alternative_neighborhood) {
                title.push(duplicatedProperty.alternative_neighborhood.name);
            } else if (duplicatedProperty.neighborhood_id && duplicatedProperty.neighborhood) {
                title.push(duplicatedProperty.neighborhood.name);
            }

            if (duplicatedProperty.city_id && duplicatedProperty.city) {
                let part = [];
                part.push(duplicatedProperty.city.name);
                if (duplicatedProperty.sell_price && !duplicatedProperty.website_hide_sell_price) {
                    part.push(humanizeMoney(duplicatedProperty.sell_price));
                }
                title.push(part.join(" - "));
            } else if (duplicatedProperty.sell_price && !duplicatedProperty.website_hide_sell_price) {
                title.push(humanizeMoney(duplicatedProperty.sell_price));
            }

            title.push(`Cod: $cod`)

            duplicatedProperty.website_title = title.join(", ");
        },
        fillKeywords(active = false) {
            let keywords = [];
            let { duplicatedProperty } = this;

            if (!duplicatedProperty) {
                return
            }

            if (!duplicatedProperty.is_website_keywords_automatic && !active) {
                return
            }

            const type = duplicatedProperty.typeInfo
            const neighborhood = duplicatedProperty.neighborhood || duplicatedProperty.alternative_neighborhood
            const city = duplicatedProperty.city

            let negotiation = null

            if (duplicatedProperty.for_sale) {
                negotiation = 'à Venda'
            } else if (duplicatedProperty.for_rent) {
                negotiation = 'para Alugar'
            }

            const hasNegotiation = negotiation !== null


            const dormCount = duplicatedProperty.roomsCount.dorm

            if (type && neighborhood) {
                keywords.push(`${type.name} em ${neighborhood.name}`)
            }

            if (type && city) {
                keywords.push(`${type.name} em ${city.name}`)
            }

            if (type && dormCount) {
                const d = plural(dormCount, "%s dorm", "%s dorms")
                keywords.push(`${type.name} com ${d}`)
            }

            if (type && hasNegotiation && neighborhood) {
                keywords.push(`${type.name} ${negotiation} em ${neighborhood.name}`)
            }

            if (type && hasNegotiation && dormCount) {
                const d = plural(dormCount, "%s dorm", "%s dorms")
                keywords.push(`${type.name} ${negotiation} com ${d}`)
            }

            duplicatedProperty.website_keywords = keywords.join(", ");
        },
    }
}
</script>


// WEBPACK FOOTER //
// DuplicateModal.vue?46704e1e